export { default as ResultsSection } from './ResultsSection';
